export default __webpack_public_path__ + "static/productivity-e00457c454c8f69d87b199cf024abb5e.png";